
import React, { useState, useEffect } from "react";
import { FadeLoader } from "react-spinners";
const Loader = () => {
  

  return <FadeLoader color="#808080" width="4" height="20" />;
  
};

export default Loader;
